import { render, staticRenderFns } from "./Split.vue?vue&type=template&id=243fec40&"
import script from "./Split.vue?vue&type=script&lang=ts&"
export * from "./Split.vue?vue&type=script&lang=ts&"
import style0 from "./Split.vue?vue&type=style&index=0&id=243fec40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
